const INTERVIEW_TYPES = {
  hireflix: "HIREFLIX",
  platform: "PLATFORM",
};

const INTERVIEW_TYPES_HUMANIZED = {
  [INTERVIEW_TYPES.hireflix]: "Hireflix",
  [INTERVIEW_TYPES.platform]: "Platform",
};

export { INTERVIEW_TYPES_HUMANIZED };

export default INTERVIEW_TYPES;
